import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
import { breakpoint } from '../../../vendorjs/breakpoint-helper.vendor';
export var listingFilters = function listingFilters() {
  Alpine.data('listingFilters', function () {
    return {
      filtersOpen: false,
      init: function init() {
        this.filtersOpen = !breakpoint.isMobile;
      },
      bindListings: {
        // eslint-disable-next-line func-names
        '@resize.window.stop.debounce': function resizeWindowStopDebounce() {
          this.filtersOpen = !breakpoint.isMobile;
        }
      }
    };
  });
};